const tours = {
  tour: "Paglilibot", // translated 
  tours: "Mga Paglilibot", // translated 
  addOn: "Dagdagan", // translated 
  addOns: "Mga Dagdag na Gamit", // translated 
  availableEscapes: "Mga Magagamit na Pagtakas", // translated 
  availableExperiences: "Mga Magagamit na Karanasan", // translated 
  getRequest: "Kumuha ng Kahilingan", // translated 
  sendRequest: "Ipadala ang Kahilingan", // translated 
};


export default tours;
